import styled from "styled-components";
import { Modal as ModalAnt } from "antd";

export const Modal = styled(ModalAnt)`
  overflow-y: auto;
`;

export const JsonBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const JsonItemTitle = styled.div`
  font-weight: 600;
  margin-top: 6px;

  &:first-child {
    margin-top: 0;
  }
`;

export const JsonItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 12px;
`;

export const JsonFieldLabel = styled.span`
  font-weight: 600;

  &::after {
    content: ":";
  }
`;
